import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as NavRightIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-right.svg';

const DetailSidebarWhiteBanner = () => {
  const bannerImageUrl = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/img-jobboard-banner.svg`;
  const bannerAirplaneImageUrl = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/img-jobboard-airplane.svg`;
  const navigate = useNavigate();

  return (
    <div
      className='flex flex-col items-center pt-1.5 pb-4 w-full tabletV:max-w-[274px] isolate
    bg-grayscale-gray00 border-grayscale-gray02 border-[1.6px] rounded-lg'
    >
      <img src={bannerImageUrl} alt='default banner' />
      <div className='flex flex-col gap-3'>
        <div className='flex font-semibold text-green-deep04 text-[34px] gap-[1px]'>
          <div>K-PATH</div>
          <img
            src={bannerAirplaneImageUrl}
            alt='default banner airplane'
            className='-mt-1'
          />
          <div>PORT</div>
        </div>

        <div className='typo-b12Strong text-grayscale-gray04 -mt-1'>
          <div className='flex gap-1'>
            <span className='text-green-deep04'>Career gap</span>
            <span>diagnosis</span>
          </div>
          <div className='flex gap-1'>
            <span>and</span>
            <span className='text-green-deep04'>skill support</span>
          </div>
        </div>

        <div
          className='group typo-b12Strong text-green-deep04 flex justify-between gap-2 cursor-pointer'
          onClick={() => navigate('/community/kpathport/pathfeed')}
        >
          <div className='flex justify-end items-end group-hover:underline'>
            Explore more
          </div>
          <div className='flex justify-center items-center p-1.5 gap-2.5 bg-grayscale-gray01 rounded-full'>
            <NavRightIcon className='-rotate-45' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailSidebarWhiteBanner;
